import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { I18nProvider } from "@humaniti/i18n";
import { initObservability } from "@humaniti/observability";
import "@humaniti/ui/css";
import "./marketing.css";
import { App } from "./App";

initObservability({
  serviceName: "humaniti-marketing",
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_HUMANITI_RELEASE ?? "dev",
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  sentryTracesSampleRate: 0.1,
  otelEndpoint: import.meta.env.VITE_OTEL_ENDPOINT,
  webVitalsEndpoint: import.meta.env.VITE_WEB_VITALS_ENDPOINT,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </StrictMode>
);
